import React from 'react';
import { PiPencilBold } from "react-icons/pi";
import { Link } from "react-router-dom"; // Added for sidebar links

const AddProcedureGroup = () => {
  const handleSave = () => {
    // Save logic
    alert('Procedure Group Saved Successfully!');
  };

  return (
    <>

      <div style={{ width: "1900px", margin: "0 auto", padding: "0px" }}>
        <div className="row">
   
          <div className="col-md-10">
            <h2
              style={{
                color: '#333',
                margin: '0 0 10px 0',
                fontSize: '20px',
                fontWeight: 'bold',
              }}
            >
              Add Procedure Group
            </h2>
            <div
              style={{
                color: '#004aad',
                marginTop: '40px',
                cursor: 'pointer',
                margin: '0 0 0 0',
                fontWeight: 'bold',
              }}
            >
              Details
            </div>
            <div
              style={{
                backgroundColor: '#f4f4f4',
                padding: '10px',
                borderRadius: '4px',
                display: 'flex',
                alignItems: 'center',
                borderTop: '2px solid #004aad',
                marginBottom: '20px',
              }}
            >
              <label style={{ color: '#333', marginRight: '10px' }}>
                Name <span style={{ color: '#ff0000' }}>*</span>
              </label>
              <input
                type="text"
                style={{ padding: '5px', border: '1px solid #ccc', marginLeft: '60px' }}
              />
            </div>

            <h2
              style={{
                color: '#004aad',
                marginBottom: '10px',
                paddingBottom: '5px',
              }}
            >
              Procedures
            </h2>
            <div
              style={{
                backgroundColor: '#f4f4f4',
                padding: '10px',
                borderRadius: '4px',
                borderTop: '2px solid #004aad',
                marginBottom: '20px',
              }}
            >
              <div style={{ display: 'flex', alignItems: 'center', padding: '5px 0' }}>
                <span>1-7 Aligners (Dual Arch)</span>
                <input type="checkbox" style={{ marginLeft: '10px' }} />
              </div>
              <div style={{ display: 'flex', alignItems: 'center', padding: '5px 0' }}>
                <span>1-7 Aligners (Single Arch)</span>
                <input type="checkbox" style={{ marginLeft: '10px' }} />
              </div>
              <div style={{ display: 'flex', alignItems: 'center', padding: '5px 0' }}>
                <span>3D Printed Models</span>
                <input type="checkbox" style={{ marginLeft: '10px' }} />
              </div>
              <div style={{ display: 'flex', alignItems: 'center', padding: '5px 0' }}>
                <span>3D Printed Model (Horse Shoe Shape)</span>
                <input type="checkbox" style={{ marginLeft: '10px' }} />
              </div>
              <div style={{ display: 'flex', alignItems: 'center', padding: '5px 0' }}>
                <span>3D Printed Study Models</span>
                <input type="checkbox" style={{ marginLeft: '10px' }} />
              </div>
              <div style={{ display: 'flex', alignItems: 'center', padding: '5px 0' }}>
                <span>60% Precious Gold Crown</span>
                <input type="checkbox" style={{ marginLeft: '10px' }} />
              </div>
              <div style={{ display: 'flex', alignItems: 'center', padding: '5px 0' }}>
                <span>8-14 Aligners (Dual Arch)</span>
                <input type="checkbox" style={{ marginLeft: '10px' }} />
              </div>
              <div style={{ display: 'flex', alignItems: 'center', padding: '5px 0' }}>
                <span>8-14 Aligners (Single Arch)</span>
                <input type="checkbox" style={{ marginLeft: '10px' }} />
              </div>
              <div style={{ display: 'flex', alignItems: 'center', padding: '5px 0' }}>
                <span>Abutment Transfer Jig</span>
                <input type="checkbox" style={{ marginLeft: '10px' }} />
              </div>
              <div style={{ display: 'flex', alignItems: 'center', padding: '5px 0' }}>
                <span>A-P added surgery sleeves</span>
                <input type="checkbox" style={{ marginLeft: '10px' }} />
              </div>
            </div>

            {/* Save Button */}
            <div style={{ display: 'flex', justifyContent: 'flex-start', marginTop: '20px' }}>
              <button
                onClick={handleSave}
                style={{
                  backgroundColor: '#004aad',
                  color: 'white',
                  padding: '10px 10px',
                  border: 'none',
                  borderRadius: '4px',
                  cursor: 'pointer',
                  fontSize: '16px',
                  fontWeight: 'bold',
                  display: 'flex',
                  alignItems: 'center',
                  gap: '10px',
                }}
              >
                <PiPencilBold /> Save
              </button>
            </div>
          </div>
        </div>
      </div>

    </>
  );
};

export default AddProcedureGroup;